import PropTypes from 'prop-types'

// TODO this needs to be updated also
import Blackhole from 'components/icons/attacks/Blackhole'
import Cpu from 'components/icons/attacks/Cpu'
import Disk from 'components/icons/attacks/Disk'
import Dns from 'components/icons/attacks/Dns'
import Io from 'components/icons/attacks/Io'
import Latency from 'components/icons/attacks/Latency'
import Memory from 'components/icons/attacks/Memory'
import Packets from 'components/icons/attacks/Packets'
import ProcessKiller from 'components/icons/attacks/ProcessKiller'
import Shutdown from 'components/icons/attacks/Shutdown'
import TimeTravel from 'components/icons/attacks/TimeTravel'
import StatusCheck from 'components/icons/StatusCheck'

import theme from '../../theme'

const ATTACK_ICONS = {
  blackhole: Blackhole,
  cpu: Cpu,
  disk: Disk,
  dns: Dns,
  io: Io,
  latency: Latency,
  memory: Memory,
  packet_loss: Packets,
  process_killer: ProcessKiller,
  shutdown: Shutdown,
  time_travel: TimeTravel,
  fallback: TimeTravel,
  status_check: StatusCheck
}

export default function AttackTypeIcon({
  className = '',
  icon = 'fallback',
  ...rest
}) {
  const objectKey = icon.replace('--', '').toLowerCase()
  const IconComponent = ATTACK_ICONS[objectKey] || ATTACK_ICONS.fallback
  return (
    <IconComponent
      className={className}
      css={{ fontSize: theme.fontSizes[4], color: theme.colors.gray[1] }}
      {...rest}
    />
  )
}

AttackTypeIcon.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string
}
